import { Action } from '@reduxjs/toolkit';
import { Epic, combineEpics } from 'redux-observable';
import { filter, from, map, mergeMap } from 'rxjs';

import { catchAndLogError } from 'utils/common';

import * as api from './svgs.api';

import actions from './svgs.actions';
import utils from './svgs.utils';

import type { RootState } from 'store/wos_store';

const getSVGImageEpic: Epic<Action, Action, RootState> = (action$, state$) =>
  action$.pipe(
    filter(actions.getSVGImage.pending.match),
    mergeMap(({ payload }) =>
      from(api.get(payload)).pipe(
        map((fetched) => {
          const svg = utils.toParseableSVG(fetched.data).querySelector('svg');
          const dataBorderColor = svg?.dataset.borderColor;

          return actions.getSVGImage.fulfilled({
            ...fetched,
            status: 'loaded',
            hasBorderColor: !!dataBorderColor && dataBorderColor === 'true',
            hideBorderColor: !!dataBorderColor && dataBorderColor === 'false',
          });
        }),
        catchAndLogError(actions.getSVGImage.rejected)
      )
    )
  );
const combined = combineEpics(getSVGImageEpic);
export default combined;
